var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBOs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 823,
    viewBox: "0 0 604 823",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.154 351.029L351.19 6.64031L346.546 4.65779L353.553 0.638428C354.396 0.165968 355.357 -0.0521342 356.321 0.010525C357.285 0.0731842 358.21 0.41391 358.985 0.991473L822.895 268.904C824.851 270.161 826.439 271.914 827.498 273.984C828.557 276.055 829.049 278.368 828.924 280.69L770.399 627.849C770.338 628.6 770.08 629.322 769.65 629.942C769.221 630.562 768.637 631.058 767.955 631.38L761.111 635.345L759.916 628.936L760.324 629.071L299.183 362.924C297.2 361.668 295.594 359.9 294.532 357.806C293.471 355.712 292.995 353.371 293.154 351.029V351.029Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.907 366.998L755.845 634.856C759.43 636.92 762.498 635.725 763.123 632.141L821.648 284.873C821.773 282.551 821.281 280.238 820.222 278.167C819.163 276.097 817.575 274.344 815.619 273.087L351.654 5.22866C348.07 3.16466 345.028 4.35961 344.376 7.94444L285.878 355.212C285.742 357.536 286.229 359.853 287.289 361.926C288.349 363.998 289.943 365.749 291.907 366.998V366.998Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.736 27.3916L804.945 285.581L749.488 612.535L302.579 354.508L357.736 27.3916Z",
    fill: "#27AE60"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.147796 531.464L25.4589 544.69L279.358 398.038C281.981 396.849 284.848 396.294 287.725 396.417C290.603 396.54 293.411 397.337 295.924 398.744L733.899 651.475C738.108 649.139 757.2 639.96 757.2 639.96L747.939 664.103C747.428 665.37 746.459 666.398 745.224 666.982L477.827 821.347C475.206 822.541 472.341 823.102 469.463 822.984C466.585 822.866 463.776 822.073 461.261 820.668L13.1564 561.962C11.4738 561.109 10.1396 559.698 9.38145 557.97V557.97L0.147796 531.464Z",
    fill: "#666262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16901 535.512L463.408 800.654C465.989 802.08 468.866 802.886 471.812 803.008C474.758 803.131 477.692 802.567 480.382 801.36L754.432 643.138C758.777 640.613 758.234 636.24 753.21 633.334L293.97 368.192C291.39 366.766 288.513 365.96 285.567 365.838C282.621 365.715 279.687 366.28 276.997 367.486L2.86541 525.708C-1.39838 528.234 -0.855191 532.606 4.16901 535.512Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.17007 532.798L463.409 797.94C465.99 799.366 468.867 800.172 471.813 800.294C474.759 800.417 477.693 799.853 480.383 798.646L754.433 640.424C755.669 639.814 756.636 638.77 757.149 637.491C757.49 638.602 757.4 639.8 756.896 640.847C756.393 641.894 755.513 642.713 754.433 643.14L480.383 801.362C477.693 802.568 474.759 803.133 471.813 803.01C468.867 802.888 465.99 802.082 463.409 800.656L4.17007 535.514C0.775335 533.558 -0.528279 530.924 0.313615 528.643C1.0432 530.455 2.41653 531.935 4.17007 532.798Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M601.915 743.296V738.272C601.915 737.783 601.643 737.566 601.263 737.756L583.502 748.022C583.305 748.166 583.144 748.354 583.031 748.571C582.918 748.787 582.856 749.027 582.85 749.271V754.295C582.85 754.784 583.149 755.001 583.502 754.784L601.263 744.545C601.465 744.405 601.629 744.218 601.743 744.001C601.856 743.783 601.915 743.541 601.915 743.296Z",
    fill: "#27AE60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M575.352 758.641V753.59C575.352 753.128 575.054 752.911 574.701 753.101L556.939 763.367C556.743 763.506 556.582 763.689 556.469 763.901C556.356 764.113 556.294 764.348 556.288 764.589V769.64C556.288 770.102 556.586 770.346 556.939 770.129L574.701 759.863C574.897 759.724 575.058 759.541 575.171 759.329C575.284 759.117 575.346 758.882 575.352 758.641V758.641Z",
    fill: "#27AE60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M682.981 628.311L301.358 407.979C300.12 407.264 298.715 406.888 297.285 406.888C295.855 406.888 294.45 407.264 293.211 407.979L157.422 486.737C156.976 486.991 156.605 487.358 156.347 487.802C156.089 488.245 155.953 488.75 155.953 489.263C155.953 489.776 156.089 490.28 156.347 490.724C156.605 491.167 156.976 491.535 157.422 491.788L538.691 711.93C539.929 712.645 541.334 713.022 542.765 713.022C544.195 713.022 545.6 712.645 546.838 711.93L682.926 633.389C683.375 633.137 683.748 632.77 684.01 632.328C684.272 631.885 684.413 631.38 684.419 630.866C684.424 630.351 684.294 629.844 684.042 629.396C683.789 628.947 683.423 628.573 682.981 628.311Z",
    fill: "#3C503B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M682.98 633.389L681.623 634.177L301.413 414.633C300.174 413.918 298.769 413.541 297.339 413.541C295.909 413.541 294.504 413.918 293.265 414.633L158.752 492.44L157.394 491.653C156.948 491.399 156.578 491.031 156.32 490.588C156.062 490.144 155.926 489.64 155.926 489.127C155.926 488.614 156.062 488.11 156.32 487.666C156.578 487.222 156.948 486.855 157.394 486.601L293.184 407.843C294.422 407.128 295.827 406.752 297.257 406.752C298.688 406.752 300.093 407.128 301.331 407.843L682.98 628.311C683.426 628.569 683.796 628.939 684.053 629.384C684.31 629.83 684.446 630.336 684.446 630.85C684.446 631.365 684.31 631.87 684.053 632.316C683.796 632.762 683.426 633.132 682.98 633.389V633.389Z",
    fill: "#335722"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.89 427.914L614.379 619.296L629.126 610.795L297.61 419.387L282.89 427.914Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.744 448.77L557.674 628.283L572.421 619.783L261.491 440.27L246.744 448.77Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223.223 462.348L589.283 673.718L604.03 665.217L237.942 453.848L223.223 462.348Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.679 475.953L565.767 687.296L580.487 678.795L214.426 467.426L199.679 475.953Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M176.131 489.534L542.219 700.876L556.966 692.376L190.878 481.033L176.131 489.534Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M582.413 642.57L612.993 660.222L627.74 651.722L597.16 634.069L582.413 642.57Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.666 681.648L183.765 622.227C179.745 619.918 179.745 616.143 183.765 613.808L254.131 573.207C256.384 572.055 258.878 571.455 261.409 571.455C263.939 571.455 266.434 572.055 268.687 573.207L371.588 632.601C375.608 634.937 375.608 638.684 371.588 641.02L301.222 681.757C298.954 682.868 296.458 683.437 293.931 683.418C291.405 683.399 288.918 682.793 286.666 681.648V681.648Z",
    fill: "url(#paint0_linear_1545_1458)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.587 636.053L268.686 576.631C266.426 575.503 263.934 574.916 261.408 574.916C258.882 574.916 256.39 575.503 254.129 576.631L183.763 617.368C182.707 617.952 181.833 618.817 181.238 619.867C180.179 617.83 180.993 615.549 183.763 613.919L254.129 573.318C256.383 572.167 258.877 571.566 261.408 571.566C263.938 571.566 266.433 572.167 268.686 573.318L371.587 632.712C374.303 634.315 375.199 636.596 374.113 638.633C373.549 637.539 372.669 636.64 371.587 636.053V636.053Z",
    fill: "#9198DB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M506.155 608.704L605.091 547.816L382.641 419.387L277.676 489.97L506.155 608.704Z",
    fill: "url(#paint1_radial_1545_1458)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M605.09 547.815L627.74 404.666L419.004 284.927V440.107L605.09 547.815Z",
    fill: "url(#paint2_radial_1545_1458)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M397.173 215.4L419.252 202.663C419.418 202.557 419.612 202.5 419.809 202.5C420.006 202.5 420.199 202.557 420.366 202.663L697.077 362.487C697.572 362.845 697.978 363.314 698.26 363.856C698.543 364.398 698.696 364.999 698.707 365.61V417.862C698.72 418.087 698.685 418.312 698.606 418.522C698.526 418.733 698.403 418.924 698.245 419.084V419.084L675.948 431.93L675.758 406.7L420.474 259.287C419.98 258.927 419.576 258.458 419.294 257.916C419.011 257.375 418.857 256.775 418.845 256.164V238.158L397.173 215.4Z",
    fill: "url(#paint3_linear_1545_1458)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M398.149 272.108L674.86 431.878C675.757 432.394 676.49 431.878 676.49 430.628V378.404C676.484 377.792 676.333 377.19 676.05 376.647C675.766 376.104 675.359 375.636 674.86 375.281L398.149 215.511C397.253 214.995 396.52 215.511 396.52 216.76V268.985C396.53 269.596 396.683 270.197 396.966 270.739C397.248 271.281 397.654 271.75 398.149 272.108V272.108Z",
    fill: "#999999"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M436.331 261.545L651.774 388.209C644.949 394.126 638.676 400.653 633.035 407.709L415.99 282.402C422.061 274.792 428.875 267.805 436.331 261.545V261.545Z",
    fill: "#24126A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M406.052 256.411L666.957 407.056C667.582 407.409 668.098 407.056 668.098 406.214V393.097C668.087 392.675 667.979 392.262 667.781 391.889C667.583 391.517 667.301 391.196 666.957 390.951L406.052 240.306C405.427 239.953 404.938 240.306 404.938 241.175V254.293C404.95 254.707 405.056 255.114 405.249 255.481C405.442 255.848 405.717 256.166 406.052 256.411Z",
    fill: "#145931"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M406.052 240.305L411.347 243.374V250.462C411.358 250.884 411.466 251.297 411.664 251.67C411.862 252.042 412.144 252.363 412.488 252.608L668.098 400.184V406.213C668.098 407.027 667.582 407.408 666.957 407.055L406.052 256.41C405.717 256.165 405.442 255.847 405.249 255.48C405.056 255.113 404.95 254.706 404.938 254.292V241.174C404.802 240.333 405.427 239.952 406.052 240.305Z",
    fill: "#3C503B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M259.479 821.621L42.4064 696.314C70.4061 680.02 94.0063 644.714 101.23 610.903C102.63 604.126 105.444 597.721 109.487 592.106C113.53 586.49 118.712 581.791 124.695 578.313L288.701 483.614C311.22 470.659 330.171 452.317 343.855 430.234C357.539 408.151 365.528 383.017 367.106 357.086C369.822 312.628 403.361 268.904 429.433 253.886L646.506 379.138C620.787 393.966 592.516 435.463 589.284 479.16C587.582 505.066 579.561 530.16 565.922 552.25C552.283 574.339 533.441 592.752 511.042 605.879L341.74 703.647C335.766 707.135 330.591 711.838 326.549 717.451C322.507 723.065 319.689 729.465 318.276 736.236C311.079 770.075 287.479 805.462 259.479 821.621Z",
    fill: "url(#paint4_linear_1545_1458)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M429.433 253.831L646.506 379.137C644.768 380.142 643.03 381.229 641.346 382.369L424.273 257.171C425.984 255.895 427.695 254.809 429.433 253.831Z",
    fill: "#27AE60"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.566 322.351H200.792V548.141C200.792 553.274 197.424 558.38 190.662 562.29C177.083 570.085 155.357 570.085 141.778 562.29C135.015 558.38 131.648 553.274 131.648 548.141L131.566 322.351Z",
    fill: "url(#paint5_linear_1545_1458)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M131.566 322.351H200.792V548.141C200.792 553.274 197.424 558.38 190.662 562.29C177.083 570.085 155.357 570.085 141.778 562.29C135.015 558.38 131.648 553.274 131.648 548.141L131.566 322.351Z",
    fill: "url(#paint6_linear_1545_1458)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M141.696 336.391C155.275 344.212 177.137 344.212 190.58 336.391C204.023 328.569 204.159 315.941 190.58 308.12C177.001 300.298 155.275 300.325 141.696 308.12C128.117 315.914 128.171 328.597 141.696 336.391Z",
    fill: "#71C9B9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.361 331.394C155.261 333.872 160.675 335.162 166.167 335.162C171.658 335.162 177.072 333.872 181.972 331.394C190.717 326.343 190.717 318.168 181.972 313.144C177.081 310.654 171.669 309.356 166.18 309.356C160.691 309.356 155.28 310.654 150.388 313.144C141.643 318.168 141.643 326.343 150.361 331.394Z",
    fill: "url(#paint7_linear_1545_1458)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M141.695 334.897C155.274 342.718 177.136 342.718 190.58 334.897C197.016 331.203 200.356 326.369 200.655 321.508C201.008 326.939 197.668 332.371 190.58 336.39C177.001 344.212 155.274 344.212 141.695 336.39C134.607 332.289 131.267 326.885 131.62 321.508C131.919 326.369 135.259 331.203 141.695 334.897Z",
    fill: "#1C1C1C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131.566 290.114H200.792V303.693C200.792 308.799 197.424 313.932 190.662 317.815C177.083 325.637 155.357 325.637 141.778 317.815C135.015 313.932 131.648 308.799 131.648 303.693L131.566 290.114Z",
    fill: "url(#paint8_linear_1545_1458)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.566 290.114H200.792V303.693C200.792 308.799 197.424 313.932 190.662 317.815C177.083 325.637 155.357 325.637 141.778 317.815C135.015 313.932 131.648 308.799 131.648 303.693L131.566 290.114Z",
    fill: "url(#paint9_linear_1545_1458)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M141.696 304.261C155.275 312.055 177.137 312.055 190.58 304.261C204.023 296.466 204.159 283.784 190.58 275.989C177.001 268.195 155.275 268.195 141.696 275.989C128.117 283.784 128.171 296.466 141.696 304.261Z",
    fill: "#71C9B9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M141.695 302.769C155.274 310.59 177.136 310.59 190.58 302.769C197.016 299.075 200.356 294.241 200.655 289.38C201.008 294.811 197.668 300.243 190.58 304.262C177.001 312.057 155.274 312.057 141.695 304.262C134.607 300.162 131.267 294.757 131.62 289.38C131.919 294.241 135.259 299.075 141.695 302.769Z",
    fill: "#1C1C1C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M188.815 482.581H258.149V581.191C258.149 586.297 254.782 591.43 248.019 595.313C234.441 603.135 212.578 603.135 199.135 595.313C192.373 591.43 189.005 586.297 189.005 581.191L188.815 482.581Z",
    fill: "url(#paint10_linear_1545_1458)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M188.815 482.581H258.149V581.191C258.149 586.297 254.782 591.43 248.019 595.313C234.441 603.135 212.578 603.135 199.135 595.313C192.373 591.43 189.005 586.297 189.005 581.191L188.815 482.581Z",
    fill: "url(#paint11_linear_1545_1458)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M198.943 496.621C212.522 504.415 234.384 504.415 247.828 496.621C261.271 488.827 261.406 476.144 247.828 468.35C234.249 460.555 212.387 460.555 198.943 468.35C185.5 476.144 185.419 488.827 198.943 496.621Z",
    fill: "#71C9B9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M198.945 495.129C212.524 502.95 234.386 502.95 247.829 495.129C254.265 491.436 257.606 486.601 257.905 481.74C258.258 487.172 254.917 492.603 247.829 496.623C234.25 504.417 212.388 504.417 198.945 496.623C191.857 492.522 188.516 487.117 188.869 481.74C189.168 486.601 192.508 491.436 198.945 495.129Z",
    fill: "#1C1C1C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M246.063 465.011H315.179V614.107C315.179 619.213 311.812 624.319 305.05 628.229C291.471 636.051 269.608 636.051 256.165 628.229C249.403 624.319 246.036 619.213 246.036 614.107L246.063 465.011Z",
    fill: "url(#paint12_linear_1545_1458)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M246.063 465.011H315.179V614.107C315.179 619.213 311.812 624.319 305.05 628.229C291.471 636.051 269.608 636.051 256.165 628.229C249.403 624.319 246.036 619.213 246.036 614.107L246.063 465.011Z",
    fill: "url(#paint13_linear_1545_1458)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M256.193 479.133C269.772 486.955 291.634 486.955 305.077 479.133C318.52 471.312 318.656 458.683 305.077 450.889C291.498 443.095 269.636 443.068 256.193 450.889C242.75 458.711 242.668 471.339 256.193 479.133Z",
    fill: "#71C9B9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.194 477.666C269.773 485.46 291.635 485.46 305.078 477.666C311.515 473.946 314.855 469.139 315.154 464.277C315.507 469.709 312.167 475.14 305.078 479.133C291.5 486.954 269.637 486.954 256.194 479.133C249.106 475.059 245.766 469.627 246.119 464.277C246.418 469.139 249.758 473.946 256.194 477.666Z",
    fill: "#1C1C1C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M303.312 524.894H372.538V647.104C372.538 652.237 369.17 657.342 362.408 661.253C348.829 669.047 327.103 669.047 313.524 661.253C306.761 657.342 303.394 652.237 303.394 647.104L303.312 524.894Z",
    fill: "url(#paint14_linear_1545_1458)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M303.312 524.894H372.538V647.104C372.538 652.237 369.17 657.342 362.408 661.253C348.829 669.047 327.103 669.047 313.524 661.253C306.761 657.342 303.394 652.237 303.394 647.104L303.312 524.894Z",
    fill: "url(#paint15_linear_1545_1458)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M313.442 539.042C327.021 546.837 348.747 546.837 362.326 539.042C375.905 531.248 375.905 518.565 362.326 510.771C348.747 502.977 327.021 502.949 313.442 510.771C299.863 518.592 299.917 531.221 313.442 539.042Z",
    fill: "#71C9B9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M313.44 537.547C327.019 545.369 348.745 545.369 362.324 537.547C368.761 533.826 372.101 529.019 372.4 524.158C372.753 529.59 369.413 535.021 362.324 539.041C348.745 546.835 327.019 546.835 313.44 539.041C306.352 534.94 303.012 529.508 303.365 524.158C303.663 529.019 307.031 533.826 313.44 537.547Z",
    fill: "#1C1C1C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M360.56 588.036H429.813V680.128C429.813 685.234 426.418 690.367 419.656 694.251C406.077 702.072 384.215 702.072 370.772 694.251C364.009 690.367 360.642 685.234 360.642 680.128L360.56 588.036Z",
    fill: "url(#paint16_linear_1545_1458)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M360.56 588.036H429.813V680.128C429.813 685.234 426.418 690.367 419.656 694.251C406.077 702.072 384.215 702.072 370.772 694.251C364.009 690.367 360.642 685.234 360.642 680.128L360.56 588.036Z",
    fill: "url(#paint17_linear_1545_1458)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M370.69 602.075C384.269 609.869 406.131 609.869 419.574 602.075C433.017 594.281 433.153 581.598 419.574 573.804C405.995 566.009 384.133 566.009 370.69 573.804C357.247 581.598 357.165 594.362 370.69 602.075Z",
    fill: "#71C9B9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M370.693 600.689C384.272 608.51 406.134 608.51 419.577 600.689C426.014 596.968 429.354 592.161 429.653 587.3C430.006 592.731 426.666 598.163 419.577 602.182C405.999 609.977 384.136 609.977 370.693 602.182C363.605 598.082 360.265 592.677 360.618 587.3C360.944 592.161 364.257 596.995 370.693 600.689Z",
    fill: "#1C1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_1458",
    x1: 374.603,
    y1: 627.414,
    x2: 180.75,
    y2: 627.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1545_1458",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(536.599 514.059) rotate(180) scale(217.127 217.127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1545_1458",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(584.097 416.371) rotate(180) scale(166.179 166.179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1545_1458",
    x1: 643.929,
    y1: 464.356,
    x2: 497.521,
    y2: 200.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61D757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5CD986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#81DF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#82E886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A3F5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#BCFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1545_1458",
    x1: 200.71,
    y1: 807.689,
    x2: 510.391,
    y2: 258.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#C2EAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CCCBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DBDBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#D7F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CAF8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C1F6F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BFF6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CFF9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E9FDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1545_1458",
    x1: 200.819,
    y1: 445.158,
    x2: 131.974,
    y2: 445.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D2D1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1545_1458",
    x1: 277.917,
    y1: 445.273,
    x2: 144.923,
    y2: 445.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5CD9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6ADFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82E8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1545_1458",
    x1: 127.799,
    y1: 313.144,
    x2: 112.03,
    y2: 340.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5C66D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6A73DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8289E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3A7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1545_1458",
    x1: 200.819,
    y1: 306.871,
    x2: 131.974,
    y2: 306.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D2D1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1545_1458",
    x1: 277.917,
    y1: 306.902,
    x2: 144.923,
    y2: 306.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5CD9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6ADFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82E8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1545_1458",
    x1: 258.068,
    y1: 541.785,
    x2: 189.223,
    y2: 541.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D2D1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1545_1458",
    x1: 335.396,
    y1: 541.895,
    x2: 202.193,
    y2: 541.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5CD9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6ADFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82E8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1545_1458",
    x1: 315.315,
    y1: 549.553,
    x2: 246.47,
    y2: 549.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D2D1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1545_1458",
    x1: 392.214,
    y1: 549.574,
    x2: 259.376,
    y2: 549.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5CD9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6ADFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82E8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1545_1458",
    x1: 372.565,
    y1: 595.993,
    x2: 303.72,
    y2: 595.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D2D1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1545_1458",
    x1: 449.663,
    y1: 596.013,
    x2: 316.669,
    y2: 596.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5CD9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6ADFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82E8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1545_1458",
    x1: 429.813,
    y1: 644.09,
    x2: 360.968,
    y2: 644.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D2D1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1545_1458",
    x1: 506.968,
    y1: 644.09,
    x2: 373.922,
    y2: 644.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D7B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5CD9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#6ADFCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#82E8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#A3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBOs);
export default __webpack_public_path__ + "static/media/bOS.8efb3b7dd33addea8120bfe1e93fcfe0.svg";
export { ForwardRef as ReactComponent };